import React from 'react'
import Icon from './Icon'

function GithubAltIcon(props) {
  return <Icon brand label="github-alt" {...props} />
}

export default GithubAltIcon;
